<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>销售业务订单审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div @click="handleAdd('')">
            <p class="flex-rowl"><i class="iconfont icon-xinzeng"></i> 新增订单</p>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="handleSearch"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示订单列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div
                class="content_wrap flex-between"
                @click="handleDetail(item.id, item.openid)"
              >
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      订单编号：<span>{{ item.orderno }}</span>
                    </p>
                    <p>
                      创建时间：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      {{item.ordertypestr}}
                    </p>
                    <p>
                      销售专员姓名：<span>{{ item.saler }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <div class="shop_name_num_item flex-rowl">
                      <p class="label">商品数量：</p>
                      <p>
                        <span>{{ item.totalNum }}</span>
                      </p>
                    </div>
                    <p v-for="(itemChild, indexChild) in item.goods" :key="indexChild">
                      商品名称：<span>{{ itemChild.commodityname }}</span>
                    </p>
                    <div class="shop_price" v-if="false">
                      <p>
                        成本参考价：<span v-if="item.cbprice_sum"
                          >¥ {{ item.cbprice_sum }}</span
                        >
                      </p>
                      <p>
                        基础零售价：<span v-if="item.price_sum"
                          >¥ {{ item.price_sum }}</span
                        >
                      </p>
                      <p>
                        批发参考价：<span v-if="item.pfprice_sum"
                          >¥ {{ item.pfprice_sum }}</span
                        >
                      </p>
                      <p>
                        基础批发价：<span v-if="item.groupprice_sum"
                          >¥ {{ item.groupprice_sum }}</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="block" v-if="false">
                    <div
                      class="shop_item"
                      v-for="(itemChild, itemIndex) in item.goods"
                      :key="itemIndex"
                    >
                      <div class="shop_name_num">
                        <!-- <div class="shop_name_num_item flex-rowl">
                          <p class="label">商品名称：</p>
                          <p>
                            <span>{{ itemChild.commodityname }}</span>
                          </p>
                        </div> -->
                        <div class="shop_name_num_item flex-rowl">
                          <p class="label">商品数量：</p>
                          <p>
                            <span>{{ itemChild.num }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="shop_price">
                        <p>成本参考价：<span></span></p>
                        <p>基础零售价：<span></span></p>
                        <p>批发参考价：<span></span></p>
                        <p>基础批发价：<span></span></p>
                      </div>
                    </div>
                  </div>
                  <div class="block">
                    <p>
                      订单价格核算：<span v-if="item.price_original"
                        >￥{{ item.price_original | formatPrice }}</span
                      >
                    </p>
                    <p>
                      物流费用：
                      <span v-if="item.logisticsdf == 1">到付</span>
            <span v-else>￥{{ item.runfee ? item.runfee : '0.00' }}</span>
                    </p>
                    <div class="txt flex-rowl">
                      <p>实际订单价格：</p>
                      <p>
                        <span>￥{{ item.price | formatPrice }}</span>
                      </p>
                    </div>
                    <!-- <div class="txt1 flex-rowl">
                      <p>差额：</p>
                      <p>
                        <span>￥{{ item.runfee }}</span>
                      </p>
                    </div> -->
                    <div class="txt2 flex-rowl">
                      <p>已付金额：</p>
                      <p>
                        <span v-if="item.paynum">￥{{ item.paynum | formatPrice }}</span>
                        <span v-else>￥ 0.00</span>
                      </p>
                    </div>
                    <div class="txt2 flex-rowl">
                      <p>差额：</p>
                      <p>
                        <span>￥{{ item.diffrentprice | formatPrice }}</span>
                      </p>
                    </div>
                    <div class="txt2 flex-rowl">
                      <p>待结清金额：</p>
                      <p>
                        <span>￥{{ item.waitMoney | formatPrice }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="block">
                    <p>
                      订单审核状态：<span class="red">{{
                        item.ischeck == 0
                          ? "待审核"
                          : item.ischeck == 1
                          ? "审核通过"
                          : item.ischeck == 2
                          ? "审核不通过"
                          : ""
                      }}</span>
                    </p>
                    <p>
                      退费申请状态：<span class="red">{{
                        item.isreturn === true
                          ? "是"
                          : item.isreturn === false
                          ? "否"
                          : "无"
                      }}</span>
                    </p>
                    <p>
                      退费状态：<span class="red">{{
                        item.returnstate ? item.returnstate : '无'}}</span>
                    </p>
                    <p>
                      订单情况：<span class="red">{{
                        item.ordertalk == 1
                          ? "进行中"
                          : item.ordertalk == 2
                          ? "已完成"
                          : item.ordertalk == 3
                          ? "已关闭"
                          : "无"
                      }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>客户名称：<span>{{item.qy_truename}}</span></p>
                    <p>客户企业：<span>{{item.qw_appidstr}}</span></p>
                    <p>客户职务：<span>{{item.qw_job}}</span></p>
                    <p>联系方式：<span>{{item.qy_linktype}}</span></p>
                  </div>
                  <div class="block">
                    <p>
                      发货统计：<span class="red"></span>
                      <!-- 发货情况：<span class="red">{{ item.orderstate }}</span> -->
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleDetail(item.id, item.openid)">
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import {encryptstringadd} from '../../../api/api'
import { getOrderListWeb } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cBusinessOrderList",
  data() {
    return {
      loading: false,
      qyid: "",
      screenList: [
        { txt: "全部", type: "", con: "" },
        { txt: "待审核", type: "ischeck", con: 0 },
        { txt: "审核通过", type: "ischeck", con: 1 },
        { txt: "审核不通过", type: "ischeck", con: 2 },
        { txt: "支付未完成", type: "paystate", con: 0 },
        { txt: "已支付完成", type: "paystate", con: 1 },
        { txt: "退费申请待审核", type: "returntalk", con: 1 },
        { txt: "退费申请不通过", type: "returntalk", con: 2 },
        { txt: "退款中", type: "orderstate", con: "已申请退费" },
        { txt: "已退款", type: "orderstate", con: "已退费" },
      ],
      select: "全部",
      dataList: [],
      listTotal: 0,
      type: "",
      params: {
        openid: "",
        ordertype: 43, // 订单类型
        keyword: "",
        qyid: "",
        returntalk: "", // 退款状态
        ischeck: "", // 订单审核
        paystate: "", // 支付状态
        orderstate: "", // 订单状态
        pageindex: 1,
        pagesize: 15
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.params.qyid = this.$store.state.USERINFO.qy
      ? this.$store.state.USERINFO.qy.id
      : "";
    // this.params.openid = this.$store.state.OPENID;
    this.getOrderListWeb();
  },
  methods: {
     handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getOrderListWeb();
    },
    // 搜索
    handleSearch() {
      this.getOrderListWeb();
    },
    // 筛选
    handleScreen(item) {
      if (item.con == "" && item.type == "") {
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "ischeck") {
        this.params.ischeck = item.con;
        this.params.returntalk = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "returntalk") {
        this.params.returntalk = item.con;
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "paystate") {
        this.params.paystate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.orderstate = "";
      } else if (item.type == "orderstate") {
        this.params.orderstate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
      }
      this.select = item.txt;
      this.getOrderListWeb();
    },
    // 重置数据
    handleRest() {
      this.params.pageindex = 1
      this.params.keyword = ''
      this.getOrderListWeb()
    },
    getOrderListWeb() {
      this.loading = true;
      getOrderListWeb(this.params).then((res) => {
        let newRes = res.list
        newRes.forEach((v) => {
          if (v.goods.length > 0) {
            v.totalNum = 0;
            v.goods.forEach((v1) => {
              v.totalNum += v1.num;
            });
          }
           // 待结清金额 = price - paynum
          v.waitMoney = calculator(v.price)
            .subtract(v.paynum ? v.paynum : 0)
            .toNumber()
        });
        this.dataList = newRes;
        this.listTotal = res.total
        this.loading = false;
      });
    },
    handleDetail(id, openid) {
      this.encryptstringadd("cOrderDetail", { id, openid, type : 'cBusinessOrderList'});
      
      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}/${this.type}`);
    },
    // 新增订单
    handleAdd() {
      this.encryptstringadd("serviceIndex", '');
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .list_wrap {
    height: 56vh;
  }
  .main_container {
    .select_add {
      p {
        &:last-child {
          // margin-left: 49px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .red {
      color: #ee0032;
    }
  }
  .intro_box {
    cursor: pointer;
    .shop_item {
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>